<template>
<div>

<v-progress-circular
        v-if="show_spinner"
        :size="12"
        :width="2"
        color="primary"
        indeterminate
        style="margin-right: 5px; margin-top: 17px;"
    />



<div :class="{ 'message_text': !is_note, 'note_text': is_note}"
    style="float:right;"
>
    <div v-if="is_text_message" v-html="getWrappedContent()" style="white-space: pre-wrap;">
    </div>

     <div v-if="is_note">
        <div
            v-html="getWrappedNoteBody()" style="white-space: pre-wrap;"
        />

        <div 
            style="text-align: right; margin-top: 10px"
            v-if="current_note.blob_labels.length > 0"
        >
            <div
                v-for="(label, index) in current_note.blob_labels"
                :key="'note_link_'+index"
            >
                <a :href="current_note.blob_urls[index]" target="_blank">
                    {{label}}
                </a>
            </div>
        </div>
    </div>

     <div v-if="is_consent_agreement" v-html="getWrappedContentConsentAgreement()" style="white-space: pre-wrap;">
        
    </div>

    <div
        v-if="is_scheduled_message"
    >
         <div
            v-html="getWrappedScheduledMessageText()" style="white-space: pre-wrap;"
        />

        <div
            style="margin-top: 15px"
        >
            <v-icon>
                mdi-alarm
            </v-icon>
            <span
                style="position: relative; top: 3px"
            >
                {{$rc.pretty(message.getTime(),'date_and_time')}}
            </span>
        </div>
        
    </div>

    <div v-if="is_red_chirp_vcard">
        <m-edit-vcard
            :value="JSON.parse(message.data.content)"
            readonly
            center_label
        />
    </div>

    <div v-if="is_red_chirp_tags_changed">

        <div v-if="message.data.rc_tags_changed.rc_added_tags.length > 0">
            <div><b>Added tags:</b></div>
            <m-rc-tag-display
                :value="message.data.rc_tags_changed.rc_added_tags"
            />
       </div>

        <div v-if="message.data.rc_tags_changed.rc_removed_tags.length > 0">
            <div><b>Removed tags:</b></div>
            <m-rc-tag-display
                :value="message.data.rc_tags_changed.rc_removed_tags"
            />
        </div>
       
    </div>

    
    <div v-if="is_long_plain_text_message" v-html="getWrappedContent()" style="white-space: pre-wrap;">
    </div>

    <div v-if="is_file_message">
        <v-icon size="30">{{blob_icon}}</v-icon>
        <a :href="blob_src_url" target="_blank" style="position: relative; top: 3px; padding-left: 3px; padding-right: 3px">{{blob_label}}</a>

        <p
            v-if="message.data.image_caption != null && message.data.image_caption.trim().length > 0"
            style="margin-top: 15px; margin-bottom: -5px"
        >
            {{message.data.image_caption}}
        </p>
    </div>

    <div v-if="is_voice_call_meta_data">
        <v-icon size="30">mdi-phone</v-icon> 
        <span style="position: relative; top: 3px; padding-left: 3px; padding-right: 7px">{{call_label}}</span>
        <p
            v-if="has_system_handling_message"
            class="font-italic"
        >
            {{system_handling_message}}
        </p>
    </div>

    <div v-if="is_video_call_meta_data">
        <v-icon size="30">mdi-video</v-icon> 
        <span style="position: relative; top: 3px; padding-left: 3px; padding-right: 7px">{{call_label}}</span>
    </div>

    <div v-if="is_voicemail">
        <b>Voicemail</b><br/>
        <audio controls :src="voicemail_url" type="audio/ogg">
        </audio>
        <br/>

        <b>Transcription</b>
        <br/>

        {{voicemail_label}}
        
    </div>
    

    <div v-if="is_payment_message">
        <v-icon 
            size="30"
            v-on:click="viewPayment"
        >
            mdi-cash-usd-outline
        </v-icon> 
        <span 
            style="position: relative; top: 3px; padding-left: 3px; padding-right: 7px; cursor: pointer;"
            v-on:click="viewPayment"
        >
            {{payment_label}}
        </span>
    </div>

    <div v-if="is_adf_send_conversation_message">
        <v-icon 
            size="30"
            v-on:click="viewPayment"
        >
            mdi-folder-account-outline
        </v-icon> 
        <span 
            style="position: relative; top: 3px; padding-left: 3px; padding-right: 7px; cursor: pointer;"
            v-on:click="viewPayment"
        >
            {{adf_label}}
        </span>
    </div>

    <m-message-content-image
        v-if="is_image_message"
        :blob_src_url="blob_src_url"
        :image_moderation_result="image_moderation_result"
        :image_caption="image_caption"
        :is_left="is_left"
    />

    <m-message-content-contact-request
        v-if="is_contact_request_message"
        :value="message.getContentAsObject()"
        :full_message="message"
    />

    <m-message-content-bulk-message-opt-event
        v-if="is_bulk_message_opt_event"
        :value="message.getContentAsObject()"
    />

    <m-message-content-vcard
        v-if="is_vcard_message"
        :value="message.getContentAsObject()"
    />
</div>
<div
    v-if="message.getState() === 'error' && user_friendly_error_message != null"
    class="error_mesage"
>
    {{user_friendly_error_message}}
    
    <span
        v-if="supports_resend"
    >
        &mdash; <a class="error_action_link" v-on:click="onResend()">{{resend_link_text}}</a>
    </span>

</div>


<div
    class="click_count_message"
    v-if="has_shortened_links"
>
    
    {{link_shortener_message}}

</div>


</div>
</template>

<script>

const Time = require('@/js/time.js');

export default {
    data() {
        return {
            force_show_image: false,
            image_moderation_result: null,
            has_shortened_links: false,
            show_in_transit_spinner: false,
        }
    },

    props: {
        message: {
            type: Object
        },

        is_left: {
            type: Boolean
        },
    },

    created () {
        this.$event_bus.$on('common-rekognition-response', this.onRekognitionResponse);
    },

    beforeDestroy () {
        this.$event_bus.$off('common-rekognition-response',this.onRekognitionResponse);
    },

    mounted() {
        if ( this.message.getBlobMetaData() != null )
        {
            let result = this.message.getBlobMetaData().data.moderation_result;
            if ( result == null ) result = 'pass';
            this.image_moderation_result = result;
        }

        this.updateShowInTransitSpinner();
    },

    methods: {

        onRekognitionResponse(response)
        {
            if (response == null) return;

            if ( this.message.data.content_type != "application/redchirp-image" || this.blob_id != response.blob_id ) return;

            this.image_moderation_result = response.moderation_result;
        },

        getWrappedContent()
        {
            let ret = this.message.getContent();
            ret = this.$rc.wrapHTML(ret,this.is_left); 

            if ( ret.toLowerCase().includes("?count_hits=false") )
            {
                this.has_shortened_links = true;
            }
            else
            {
                this.has_shortened_links = false;
            }

            return ret;
        },

        getWrappedNoteBody()
        {
            let ret = this.message.getContentAsObject().current.body;
            ret = this.$rc.wrapHTML(ret,this.is_left); 
            return ret;
        },

        getWrappedScheduledMessageText()
        {
            let ret = this.message.getContentAsObject().text;
            ret = this.$rc.wrapHTML(ret,this.is_left); 
            return ret;
        },

        getWrappedContentConsentAgreement()
        {
            let ret = JSON.parse(this.message.getContent()).text;
            return this.$rc.wrapHTML(ret);
        },

    
        viewPayment()
        {
            let payment = JSON.parse(this.message.getContent());
            let payment_id = payment.payment_id;

            this.$router.push({
                'name': 'view-payment',
                'params' : {
                    'payment_id' : payment_id,
                },
            }).catch(e=>{}); // swallow any exception
        },

        onResend()
        {
            this.$rc.showSpinner();

            this.$rc.resendMessage(
                
                this.message.getId(),

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.snackbar('Message has been resent',3500);
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to resend message');
                }
            );

        },

        onClickPlayVoicemail()
        {
            let recording_url = this.message.getContentAsObject().recording_url;
            var audio = new Audio(recording_url);
            audio.play();  
        },

        updateShowInTransitSpinner()
        {
            if ( this.message.getState() !== 'in-transit' ) 
            {
                this.show_in_transit_spinner = false;
                return;
            }

            this.show_in_transit_spinner = Date.now() - this.message.getTime() < 7500;

            if ( this.show_in_transit_spinner )
            {
                setTimeout(() => { this.show_in_transit_spinner = false; }, 7500);
            }
        },
    },

    computed: {

        is_text_message()
        {
            return this.message.isText();
        },

        is_long_plain_text_message()
        {
            return this.message.isLongPlainText();
        },

        is_image_message()
        {
            return this.message.isImage();
        },

        is_file_message()
        {
            return this.message.isFile();
        },

        is_contact_request_message()
        {
            return this.message.isContactRequest();
        },

        is_voice_call_meta_data()
        {
            return this.message.isVoiceCallMetaData();
        },

        is_note()
        {
            return this.message.isNote();
        },

        is_scheduled_message()
        {
            return this.message.isScheduledMessage();
        },

        current_note()
        {
            if ( !this.message.isNote() )
                return null;

            return this.message.getContentAsObject().current;
        },

        is_consent_agreement()
        {
            return this.message.isConsentAgreementMessage();
        },

        is_red_chirp_vcard()
        {
            return this.message.isRedChirpVCardMessage();
        },

        is_red_chirp_tags_changed()
        {
            return this.message.isRedChirpTagsChangedMessage();
        },

        is_payment_message()
        {
            return this.message.isPaymentMessage();
        },

        is_adf_send_conversation_message()
        {
            return this.message.isAdfSendConversationMessage();
        },

        is_vcard_message()
        {
            return this.message.isVCardMessage();
        },

        is_bulk_message_opt_event()
        {
            return this.message.isBulkMessageOptEvent();
        },

        is_archive_conversation()
        {
            return this.message.isArchiveConversationMessage();
        },

        is_redchirp_system_message()
        {
            return this.message.isRedChirpSystemMessage();
        },

        is_claim_conversation()
        {
            return this.message.isClaimConversationMessage();
        },

        is_bulk_message_set_outcome()
        {
            return this.message.isBulkMessageSetOutcome();
        },

        is_video_call_meta_data()
        {
            return this.message.isVideoCallMetaData();
        },

        is_voicemail()
        {
            return this.message.isVoicemailMetaData();
        },

        image_caption()
        {
            return this.message.getImageCaption();
        },

        blob_src_url()
        {
            return this.$rc.getBlobEndpoint(this.message.getBlobMetaData());
        },

        blob_id()
        {
            if ( !this.message.getBlobMetaData() ) return null;

            return this.message.getBlobMetaData().data.blob_id;
        },

        blob_image_moderation_pending()
        {
            return this.image_moderation_result == 'no-result';
        },

        blob_icon()
        {
            return this.message.getFileIcon();
        },

        blob_label()
        {
            return this.message.getBlobMetaData().getLabel();
        },

        voicemail_label()
        {
            let transcription = this.message.getContentAsObject().transcription;

            if ( transcription == null )
                return 'No transcription available';

            return transcription;
        },

        voicemail_url()
        {
            return this.message.getContentAsObject().recording_url;
        },

        call_label()
        {
            let length = Time.getHumanReadableDuration(JSON.parse(this.message.getContent()).call_length_milliseconds);
            let direction = this.is_left ? 'Incoming' : 'Outgoing';

            let type = this.message.isVoiceCallMetaData() ? 'phone call' : 'video call';

            return direction+' '+type+' ('+length+')';
        },

        payment_label()
        {
            let payment = JSON.parse(this.message.getContent());
            return payment.label;
        },

        adf_label()
        {
            let adf = JSON.parse(this.message.getContent());
            return 'Sent conversation to '+adf.system_label;
        },

        user_friendly_error_message()
        {
            if ( this.message == null ) return null;
            if ( this.message.getState() != 'error' ) return null;

            let detail = this.message.getStateDetail();

            if ( this.message.getErrorCodeDesc() != null ) return this.message.getErrorCodeDesc();

            if ( detail == 'waiting-on-delivery-confirmation' ) return null; // don't display anything while waiting...
            if ( detail == 'destination-rejected-due-to-user-opt-out' ) return "Error: this customer opted out with their phone or carrier.";
            if ( detail == 'error-phone-number-may-not-accept-sms' ) return 'Error: this phone number may not accept text messages';
            if ( detail == 'consent-denied' ) return 'Error: the customer has opted out of messaging (consent denied).';

            if ( detail == 'error-spam' ) return 'Error: recipient\'s carrier blocked as spam';
            if ( detail == 'destination-rejected-due-to-spam-detection' ) return 'Error: recipient\'s carrier blocked as spam';

            if ( detail == 'could-not-download-media' ) return 'Error: image / attachment failed to send.';
            if ( detail == 'rejected-unallocated-from-number' ) return 'Error: the sending phone number is not in service (unallocated from number)';
            if ( detail == 'rejected-unallocated-to-number' ) return 'Error: the number is not in service (unallocated to number)';

            if ( detail == 'rejected-forbidden-tollfree' ) return 'Error: the recipient has opted out of any messaging from toll free numbers';
            if ( detail == 'rejected-forbidden-tollfree-for-recipient' ) return 'Error: the recipient has opted out of any messaging from toll free numbers';

            if ( detail == 'rejected-forbidden-country' ) return 'Error: Unable to send messages to this country';

            if ( detail == 'rejected-message-size-limit-exceeded' ) return 'Error: Message is too large';


            return null;
        },

        supports_resend()
        {
            if ( this.message == null ) return false;
            if ( this.message.getState() != 'error' ) return false;

            let detail = this.message.getStateDetail();

            if ( detail == 'no-detail' || detail == 'could-not-download-media' )
                return this.message.isText() || this.message.isImage() || this.message.isFile();

            return false;
        },

        resend_link_text()
        {
            if ( this.message.isImage() )
            {
                return 'resend as link';
            }   

            return 'resend';
        },

        has_system_handling_message()
        {
            let message = JSON.parse(this.message.getContent());
            return message.system_handling_message && message.system_handling_message.length > 0;
        },

        system_handling_message()
        {
            return JSON.parse(this.message.getContent()).system_handling_message;
        },

        show_spinner() 
        {
            return this.blob_image_moderation_pending || this.show_in_transit_spinner;
        },

        link_shortener_message()
        {
            let data = this.$rc.getDeep(this.message, "data/extended_data/link_shortener_v1");
            if ( data == null || data.click_count == 0 ) return 'The link has not been clicked yet';

            if ( data.click_count == 1 )
                return 'The link has been clicked '+data.click_count+' time';
            else
                return 'The link has been clicked '+data.click_count+' times';
        }
    },

    watch: {
        message(newValue, oldValue) 
        {
            this.updateShowInTransitSpinner();
        },
    },

}
</script>

<style scoped>

.message_text,
.note_text
{
    background-color: rgb(241,243,244);
    color: rgb(32,33,36);
    display: inline-block;
    border-radius: 20px;
    font-family: Roboto;

    padding-bottom: 10px;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 10px;

    line-height: 24px;

    max-width: 460px;

    overflow-wrap: anywhere;

    margin-bottom: 15px;
}

.note_text
{
    background-color: rgb(250,250,220);
    /*border-top: 12px solid rgb(250,250,200);*/
    border-radius: 0px;
}

.msg_hyperlink
{
    word-break: break-all;
    color: blue;
}

.error_action_link
{
    text-decoration: underline;
    color: blue;
}

.error_mesage
{
    font-size: 11px; 
    color: red; 
    padding-left: 10px; 
    text-align: right;
    clear: both;

    position: relative;
    top: -12px;
}

.click_count_message
{
    font-size: 11px; 
    padding-left: 10px; 
    text-align: right;
    clear: both;

    position: relative;
    top: -12px;
}

.status_mesage
{
    font-size: 11px; 
    color: rgba(0,150,0,1.0); 
    padding-left: 10px; 
    text-align: right;
    clear: both;

    position: relative;
    top: -12px;
}

.image-moderation-container {
    position: relative;
    text-align: center;
    color: black;
}

.image-moderation-text {
    position: absolute;
    color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

</style>